import { useTranslation } from 'react-i18next';

import { Divide, Flex } from '@/lib/v2/components/Layout/Stack';

export const BackToEmblueTooltip = () => {
  const { t } = useTranslation();
  return (
    <div className="z-10 w-72 whitespace-normal p-2">
      <Divide>
        <Flex column withGap>
          <span> {t('backToLegacyTooltip')} </span>
          <p className="pt-2"> {t('BACK_TO_EMBLUE_TOOLTIP.description')}</p>
        </Flex>
      </Divide>
    </div>
  );
};
